import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPokdengStatistics implements ICommand
{

	public Player1WinCount : number = 0;
	public Player2WinCount : number = 0;
	public Player3WinCount : number = 0;
	public Player4WinCount : number = 0;
	public Player5WinCount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Player1WinCount = ba.readUint8();
		this.Player2WinCount = ba.readUint8();
		this.Player3WinCount = ba.readUint8();
		this.Player4WinCount = ba.readUint8();
		this.Player5WinCount = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.Player1WinCount);
		ba.writeUint8(this.Player2WinCount);
		ba.writeUint8(this.Player3WinCount);
		ba.writeUint8(this.Player4WinCount);
		ba.writeUint8(this.Player5WinCount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPokdengStatistics();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Player1WinCount(B)='+this.Player1WinCount+' ';
		str += 'Player2WinCount(B)='+this.Player2WinCount+' ';
		str += 'Player3WinCount(B)='+this.Player3WinCount+' ';
		str += 'Player4WinCount(B)='+this.Player4WinCount+' ';
		str += 'Player5WinCount(B)='+this.Player5WinCount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'PokdengStatistics';
	}

}
